<template>
    <div class="cbp-item practice-item" 
        @click="navigateToPractice(dash, mask)"
    >
        <div class="practice-img">
            <img :src="image" :alt="name">
        </div>
        <div class="overlay">
            <div class="text text-capitalize">{{ name }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PracticeComponent',
        props: [
            'name',
            'dash',
            'mask',
            'image'
        ],
        methods: {
            //Navigate to 
            navigateToPractice(dash, mask) {
                if (!dash && !mask) {
                    return;
                }
                this.$router.push(`/practice-areas/${dash}/${mask}`);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/frontend/PracticeComponent.vue